import { Box } from '@mui/material'
import { memo, ReactNode } from 'react'

interface Props {
  label: ReactNode
  children: ReactNode
}

const Fieldset = ({ children, label }: Props) => {
  return (
    <Box component="fieldset" sx={{ borderColor: 'divider', borderStyle: 'solid', borderWidth: 1 }}>
      <legend>{label}</legend>
      {children}
    </Box>
  )
}

export default memo(Fieldset)
